import { ErrorBaseData } from '.'

export const treatmentErrors: Record<string, ErrorBaseData> = {
  TreatmentAlreadyExistsException: {
    message: 'Este tratamento já existe',
    description: 'Já existe um tratamento para a patologia selecionada',
  },
}
